// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatChatListSectionToggle-moduletoggle__vk5D2 AIButtonTextGrey-moduleaiButtonTextGrey__mVWNT AIButtonText-moduleaiButtonText__hhww0";
export { _1 as "toggle" }
